module.exports = __webpack_public_path__ + "images/setting-icon.014ee2e3cfc1d9b0f6f1109663de0d20.png";